import PublishOptionsPanel from './PublishOptionsPanel.vue';

export default PublishOptionsPanel;
